import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchUnassignedJobOperations() {
  try {
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'job/getunassignedjobs/0',
    });
    const unassignedJobsOperationData = data;
    yield put(Actions.setUnassignedJobOperations({ unassignedJobsOperationData }));
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addUpdateUnassignedJobOperation({ actionName, unassignedJobOperationObj }) {
  try {
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
      route: 'job',
      data: unassignedJobOperationObj,
    });
    yield put(Actions.fetchUnassignedJobOperations());
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.UNASSIGNED_JOB_CREATED
        : CONSTANT_VARIABLES.UNASSIGNED_JOB_UPDATED,
      ''
    );
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteUnassignedJobOperation({ unassignedJobId }) {
  try {
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: true }));
    yield call(api.delete, {
      route: 'Job/DeleteJobById/' + unassignedJobId,
    });
    yield put(Actions.fetchUnassignedJobOperations());
    notification('success', CONSTANT_VARIABLES.UNASSIGNED_JOB_DELETED, '');
  } catch (err) {
    yield put(Actions.setUnassignedJobOperationsLoaderStatus({ unassignedJobOperationsLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_UNASSIGNED_JOBS_OPERATION, fetchUnassignedJobOperations),
    takeLatest(ActionTypes.ADD_UPDATE_UNASSIGNED_JOBS_OPERATION, addUpdateUnassignedJobOperation),
    takeLatest(ActionTypes.DELETE_UNASSIGNED_JOBS_OPERATION, deleteUnassignedJobOperation),
  ]);
}
